import React, { Component } from "react";
import PropTypes from 'prop-types';
import { graphql, Link } from "gatsby";
import Layout from "../components/layout";
// import { Card, CardImg, CardBody, CardTitle, CardText } from 'reactstrap'

class HomeLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            props: props,
            page: props.data.dataJson,
            guests: 2,
            rooms: 1,
            arrival: new Date(),
            departure: new Date() + 1
        }
        // console.log(props);
    }
    componentDidMount() {
        var date = new Date();
        var arrival = date.getDate() + "/" + date.getMonth() + 1 + "/" + date.getFullYear();
        date.setDate(date.getDate() + 1);
        var departure = date.getDate() + "/" + date.getMonth() + 1 + "/" + date.getFullYear();
        this.setState({ arrival: arrival, departure: departure });

    }
    // {/* <span className="text-white caps_large underline-primary">middle-market private equity</span> */}
    render() {
        return (
            <Layout>
                <section className="header" style={{ backgroundColor: "#5A368A", height: '100vh', backgroundImage: `url(${this.state.page.titleBackground})` }} data-scrim-top="12">
                    <div className="container d-flex flex-column justify-content-center align-items-center">
                        <h1 className="text-white text-center"><strong>The Indus India Fund - Assisting in shaping the future - investing in Medtech / Life sciences, Fintech & Electric Vehicles to create impact.</strong></h1>
                        <span><Link to="/about-us" className="btn btn-large text-white bg-secondary rounded-md" style={{fontSize: "1.1rem"}}>Know More <i className="fa fa-long-arrow-right text-white"></i></Link></span>
                    </div>    
                </section>
                <section className="section py-7 bg-pale-primary lead p-5">
                    <div className="container py-7 text-center">
                        <h1>Indus India Fund I</h1>
                        <p>An India focused venture capital firm backing exceptional founders in Fintech, MedTech, and Cleantech & Energy Transition with patient capital, operational insight, and institutional grade governance. </p>
                        <p>At Indus Equity Partners, we aim to turn resilient businesses into enduring, category defining companies by making a significant contribution to them.</p>
                    </div>
                    <div className="container py-7 text-center">
                        <h1>Our Thesis and Outlook</h1>
                        <p>We invest equity in deep-tech-enabled early-stage startups and venture debt & secondaries in late-stage technology businesses.</p>
                        <p>Our Fund is designed to capitalize on India’s digital infrastructure maturation, sustained economic growth creating an aspirational and sizable consumer base, and the prolific entrepreneurial momentum and talent pool creating confidence in both investors and policy makers.</p>
                    </div>
                </section>
            </Layout>
        )
    }
}

export const query = graphql`
  query($slug: String!) {
    dataJson(fields: { slug: { eq: $slug } }) {
      title
      subTitle
      titleBackground
      contents {
         heading
         image
         imageLeft
         content
         link
       }
    }
  }
`

HomeLayout.propTypes = {
    data: PropTypes.object
};

React.defaultProps = {
    className: 'react-remark',
};

export default HomeLayout;
